import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useEventCallback, useIsomorphicLayoutEffect } from '@cian/react-utils';
import { InputWrapper } from '../../../internal/components/InputWrapper';
import { useControlled } from '../../../internal/hooks';
import { Slider } from '../../../slider';
import { INPUT_WRAPPER_PICK_PROPS, SLIDER_PICK_PROPS } from '../../internal';
import styles from './styles.module.css';
import { IMaskInput } from '../../../internal/components/IMaskInput';
import { omit, pick } from 'ramda';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const pickSliderProps = pick(SLIDER_PICK_PROPS);
const pickInputWrapperProps = pick(INPUT_WRAPPER_PICK_PROPS);
const pickInputProps = omit([...SLIDER_PICK_PROPS, ...INPUT_WRAPPER_PICK_PROPS]);
const IMASK_OPTIONS = {
  mask: Number,
  thousandsSeparator: '\u2009',
  signed: true
};
export function InputSlider(props) {
  const {
    onChange,
    onFocus,
    onBlur,
    step = 1,
    min,
    defaultValue
  } = props;
  const [value, setValue] = useControlled({
    controlled: props.value,
    default: defaultValue !== undefined ? defaultValue : min
  });
  const [inputValue, setInputValue] = React.useState(String(value));
  const [focused, setFocused] = React.useState(false);
  const handleInputAccept = useEventCallback(eventValue => {
    setInputValue(eventValue);
    if (!eventValue) {
      return;
    }
    const nextValue = Number(eventValue);
    setValue(nextValue);
    if (onChange && nextValue !== value) {
      onChange(nextValue);
    }
  });
  const handleSliderChange = useEventCallback(nextValue => {
    setValue(nextValue);
    if (onChange) {
      onChange(nextValue);
    }
  });
  const handleFocus = useEventCallback(e => {
    setFocused(true);
    if (onFocus) {
      onFocus(e);
    }
  });
  const handleBlur = useEventCallback(e => {
    setFocused(false);
    if (onBlur) {
      onBlur(e);
    }
    const finalValue = toSliderValue(inputValue, min);
    if (onChange && value !== finalValue) {
      onChange(finalValue);
    }
  });
  useIsomorphicLayoutEffect(() => {
    setInputValue(String(value));
  }, [value]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['input-slider'],
    children: [/*#__PURE__*/_jsx(InputWrapper, _objectSpread(_objectSpread({}, pickInputWrapperProps(props)), {}, {
      focused: focused,
      size: "M",
      children: /*#__PURE__*/_jsx(IMaskInput, _objectSpread(_objectSpread({}, pickInputProps(props)), {}, {
        ref: props.inputRef,
        className: styles['input'],
        onFocus: handleFocus,
        onBlur: handleBlur,
        value: inputValue,
        options: IMASK_OPTIONS,
        onAccept: handleInputAccept,
        disabled: props.disabled,
        preventActiveUpdate: true
      }))
    })), /*#__PURE__*/_jsx("div", {
      className: styles['slider'],
      children: /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, pickSliderProps(props)), {}, {
        __theme: "input",
        value: toSliderValue(inputValue, min),
        onChange: handleSliderChange,
        step: step,
        valueLabelDisplay: "off",
        tabIndex: -1
      }))
    })]
  });
}
function toSliderValue(inputValue, min) {
  return inputValue === '' ? min : Number(inputValue);
}